/**
 * This file stores action types that are sent or listened
 * by Electron app or extenral web app that opens RWC (e.g. Jupiter).
 * They shouldn't be used as action types inside RWC.
 */

// Common actions that may be useful for both electron and web app.

export const IPC_CALL_START = 'call/start';
export const IPC_CALL_END = 'call/end';
export const IPC_CALL_SHOULD_AUTO_JOIN_AUDIO = 'call/shouldAutoJoinAudio';
export const IPC_CALL_AUDIO_JOINED = 'call/audioJoined';
export const IPC_CALL_STATE_UPDATE = 'call/state';
export const IPC_CALL_END_MEETING = 'call/endMeeting';
export const IPC_CALL_END_MEETING_FOR_ALL = 'call/endMeetingForAll';
export const IPC_CALL_FAILURE = 'call/failure';
export const IPC_CALL_END_SHARING = 'call/endSharing';
export const IPC_CALL_IN_MEETING_PROFILER_DATA = 'call/inmeetingProfilerData';

export const IPC_ONCONF_ENTERED = 'onconf/entered';
export const IPC_ONCONF_LEFT = 'onconf/left';

export const IPC_PROVIDE_WEB_VERSION = 'xUserAgent/setWebDetails';

export const IPC_MENU_SIGN_OUT = 'menu/signOut';
export const IPC_MENU_SIGN_IN = 'menu/signIn';
export const IPC_MENU_FEEDBACK = 'menu/feedback';
export const IPC_MENU_ABOUT = 'menu/about';
export const IPC_MENU_SETTINGS = 'menu/settings';

export const IPC_PING = 'ipc/ping';
export const IPC_PONG = 'ipc/pong';

export const IPC_SELF_SHARING_START = 'sharing/started_by_me';
export const IPC_SELF_SHARING_STOP = 'sharing/stopped_by_me';
export const IPC_FOREIGN_SHARING_START = 'sharing/started_by_participant';
export const IPC_FOREIGN_SHARING_STOP = 'sharing/stopped_by_participant';

// Jupiter integration IPC commands
export const IPC_CMD_SYNC_SPEAKER_VOLUME = 'consume-sync/speaker_volume';
export const IPC_CMD_SYNC_SPEAKER_DEVICE = 'consume-sync/speaker_device';
export const IPC_CMD_SYNC_MICROPHONE_DEVICE = 'consume-sync/microphone_device';
export const IPC_CMD_SYNC_DENOISE_ENABLED = 'consume-sync/denoise_enabled';

// Jupiter integration specific events
export const IPC_EXTERNAL_INITIALIZED = 'initialized';
export const IPC_EXTERNAL_ERROR = 'error';
export const IPC_EXTERNAL_NOTIFY = 'notify';
export const IPC_EXTERNAL_CHAT_NEW_MESSAGE = 'chat/newMessage';
export const IPC_ONCONF_FINISH = 'onconf/finish';
export const IPC_MODAL_CLOSE = 'modal/close';
export const IPC_CURRENT_PERMISSION_STATUS = 'currentPermissionStatus';
export const IPC_GET_USER_MEDIA_FINISH = 'getUserMediaFinish';
export const IPC_ASK_PAGE_RELOAD = 'askPageReload';
export const IPC_MODAL_OPEN = 'modal/open';

export const IPC_SYNC_SPEAKER_VOLUME = 'provide-sync/speaker_volume';
export const IPC_SYNC_SPEAKER_DEVICE = 'provide-sync/speaker_device';
export const IPC_SYNC_MICROPHONE_DEVICE = 'provide-sync/microphone_device';
export const IPC_SYNC_DENOISE_ENABLED = 'provide-sync/denoise_enabled';
export const SEND_JUPITER_LOGS = 'send-jupiter-logs';

export const IPC_SUPPORTED_COMMANDS = [
    IPC_CMD_SYNC_SPEAKER_VOLUME,
    IPC_CMD_SYNC_SPEAKER_DEVICE,
    IPC_CMD_SYNC_MICROPHONE_DEVICE,
    IPC_CMD_SYNC_DENOISE_ENABLED,
    IPC_CALL_END_MEETING,
];

// Jupiter integration IPC events

export const IPC_SUPPORTED_EVENTS = [
    IPC_CALL_END,
    IPC_CALL_START,
    IPC_CALL_AUDIO_JOINED,
    IPC_CALL_FAILURE,
    IPC_CALL_STATE_UPDATE,
    IPC_EXTERNAL_CHAT_NEW_MESSAGE,
    IPC_EXTERNAL_NOTIFY,
    IPC_ONCONF_ENTERED,
    IPC_ONCONF_LEFT,
    IPC_ONCONF_FINISH,
    IPC_EXTERNAL_INITIALIZED,
    IPC_EXTERNAL_ERROR,
    IPC_MODAL_OPEN,
    IPC_MODAL_CLOSE,
    IPC_CURRENT_PERMISSION_STATUS,
    IPC_GET_USER_MEDIA_FINISH,
    IPC_ASK_PAGE_RELOAD,
    IPC_SELF_SHARING_START,
    IPC_SELF_SHARING_STOP,
    IPC_FOREIGN_SHARING_START,
    IPC_FOREIGN_SHARING_STOP,
    IPC_SYNC_SPEAKER_VOLUME,
    IPC_SYNC_SPEAKER_DEVICE,
    IPC_SYNC_MICROPHONE_DEVICE,
    IPC_SYNC_DENOISE_ENABLED,
    SEND_JUPITER_LOGS,
    IPC_CALL_IN_MEETING_PROFILER_DATA,
];

// Hercules 2 specific events and command events

export const IPC_2_CMD_CALL_END_MEETING = 'call/finish';

// Desktop SDK specific actions, which make sense for desktop app only.

export const DESKTOP_SDK_ESC_TOOLTIP_SHOW = 'esc_tooltip/show';
export const DESKTOP_SDK_ESC_TOOLTIP_HIDE = 'esc_tooltip/hide';

export const DESKTOP_SDK_APP_PRIVACY = 'app/privacy';
export const DESKTOP_SDK_APP_TERMS = 'app/terms';
export const DESKTOP_SDK_APP_QUIT = 'app/quit';
export const DESKTOP_SDK_APP_RESTART = 'app/restart';
export const DESKTOP_SDK_APP_OPEN_IN_BROWSER = 'app/openInBrowser';
export const DESKTOP_SDK_APP_OPEN_IN_ELECTRON = 'app/openInElectron';

export const DESKTOP_SDK_UPDATE_CHECK = 'update/check';
export const DESKTOP_SDK_UPDATE_READY = 'update/ready';

export const DESKTOP_SDK_FULL_SCREEN_NATIVE = 'fullscreen/native';
export const DESKTOP_SDK_FULL_SCREEN_HTML = 'fullscreen/html';

export const DESKTOP_SDK_SMALL_SHARING_PANEL = 'floating/set_default';
export const DESKTOP_SDK_LARGE_SHARING_PANEL = 'floating/set_gallery';
export const DESKTOP_SDK_SET_PARTICIPANTS = 'floating/set_participants';

export const DESKTOP_SDK_REQUEST_SUPPORTED_LOCALES = 'l10n/request_supported_locales';
export const DESKTOP_SDK_RECEIVE_SUPPORTED_LOCALES = 'l10n/supported_locales';
export const DESKTOP_SDK_SET_LOCALE = 'l10n/set_locale';

export const DESKTOP_SDK_AEC_DUMP_START = 'debug/audio_recording_start';
export const DESKTOP_SDK_AEC_DUMP_STOP = 'debug/audio_recording_stop';
export const DESKTOP_SDK_AEC_DUMP_START_FAIL = 'debug/audio_recording_start_fail';

export const DESKTOP_SDK_PANNOTATION_SET_SOURCE = 'pannotations/set-source';
export const DESKTOP_SDK_PANNOTATION_START_IGNORE_MOUSE = 'pannotations/start-ignore-mouse';
export const DESKTOP_SDK_PANNOTATION_STOP_IGNORE_MOUSE = 'pannotations/stop-ignore-mouse';
export const DESKTOP_SDK_PA_OVERLAY_SHIFT = 'pannotations/translate-canvas';
export const DESKTOP_SDK_PATOOLBOX_START_CAPTURE_MOUSE = 'patoolbox/cursor-spy-start';
export const DESKTOP_SDK_PATOOLBOX_STOP_CAPTURE_MOUSE = 'patoolbox/cursor-spy-stop';
export const DESKTOP_SDK_PA_OVERLAY_READY = 'pannotations/window-ready';
export const DESKTOP_SDK_PA_TOOLBOX_READY = 'patoolbox/window-ready';
export const DESKTOP_SDK_PA_DIALOG_READY = 'dailog_overlay/window-ready';
